import React, { Component }  from 'react'
import { Icon, Modal, Statistic, Image, Table, Popup, Label, Input } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import orderBy from 'lodash/orderBy'
import moment from 'moment'
import { gradeSheetLink } from '../../utils/gradeSheetLink';

const _ = { find, isEmpty, orderBy }

class ReviewedModal extends Component {
  state = {
    searchKey: ''
  };

  isSearched = (searchKey) => {
    return function(item) {
      return (
        !searchKey ||
        item.section.name.toLowerCase().includes(searchKey.toLowerCase()) ||
        item.section.gradeLevel.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange = (event) => {
    this.setState({ searchKey: event.target.value });
  }
  render() {
    const {data, value, sectionSubjects, title, quarter} = this.props;

    // Add null check to prevent crashes during loading
    if (!sectionSubjects || !Array.isArray(sectionSubjects)) {
      return null; // Don't render anything if data isn't ready
    }

    const currentSectionSubjects = sectionSubjects.filter(this.isSearched(this.state.searchKey));
    const headers = (
      <Table.Row>
        <Table.HeaderCell textAlign='center'>
          Subject
        </Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>
          Section
        </Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>
          Created By
        </Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>
          Checked By
        </Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>
          Reviewed By
        </Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>
          Actions
        </Table.HeaderCell>
      </Table.Row>
    )
    const sortedData = _.orderBy(data, ['reviewedDate'], ['asc']);
    const body = sortedData.map((item, key )=> {
      if(_.isEmpty(sectionSubjects) ) return null;

      const sectionSubject = _.find(currentSectionSubjects, {
        sectionSubjectId: item.sectionSubjectId
      });
      let downloadLink;
      if (sectionSubject != null) {
        if (!_.isEmpty(item.resubmitFile3)) {
          downloadLink = gradeSheetLink(sectionSubject.subject.code, item.resubmitFile3);
        } else if (!_.isEmpty(item.resubmitFile2)) {
          downloadLink = gradeSheetLink(sectionSubject.subject.code, item.resubmitFile2);
        } else if (!_.isEmpty(item.resubmitFile)) {
          downloadLink = gradeSheetLink(sectionSubject.subject.code, item.resubmitFile);
        } else {
          downloadLink = gradeSheetLink(sectionSubject.subject.code, item.file);
        }
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell collapsing>{sectionSubject.subject.name}</Table.Cell>
            <Table.Cell collapsing>{sectionSubject.section.gradeLevel} - {sectionSubject.section.name}</Table.Cell>
            <Table.Cell textAlign='center'>
              {item.createdBy} | {moment(item.createdDate).format('MMM DD, YYYY')} |
              <Popup header='Teacher Notes' content={item.notes} basic trigger={<Icon link name='sticky note'/>} />
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {item.checkedBy} | {moment(item.checkedDate).format('MMM DD, YYYY')} |
              <Popup header='Level Head Notes' content={item.levelHeadNotes} basic trigger={<Icon link name='sticky note'/>} />
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {item.reviewedBy} | {moment(item.reviewedDate).format('MMM DD, YYYY')} |
              <Popup header='Registrar Notes' content={item.registrarNotes} basic trigger={<Icon link name='sticky note'/>} />
            </Table.Cell>
            <Table.Cell collapsing>
              {
                this.props.isGrades ?
                <NavLink to={`/grades/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
                  <Popup
                    trigger={<Icon link name='linkify' color='blue'/>}
                    content="Go to approval page."
                    basic
                  />
                </NavLink>
                :
                <NavLink to={`/conducts/${sectionSubject.sectionId}/${sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
                  <Popup
                    trigger={<Icon link name='linkify' color='blue'/>}
                    content="Go to approval page."
                    basic
                  />
                </NavLink>
              }
              {
                item.file !== '' &&
                <Popup
                  trigger={<a href={downloadLink}> <Icon link name='paperclip' color='blue'/> </a>}
                  content="Download sheet."
                  basic
                />
              }

            </Table.Cell>
          </Table.Row>
        );
      } else {
        return null;
      }

    });

    return (
      <Modal trigger={
        <Statistic className='reviewed'>
          <Statistic.Value>
            <span className='stat-value'>{value}</span>
            <Image src='dashboard/Review.png' inline />
          </Statistic.Value>
          <Statistic.Label className='stat-label'>Reviewed</Statistic.Label>
        </Statistic>
      } closeIcon size='large'>
      <Modal.Header>{title}
        <Label className='reviewed-label' horizontal>
          REVIEWED
        </Label>
      </Modal.Header>
        <Modal.Content>
          <Input
            fluid
            icon='search'
            value={this.state.searchKey}
            onChange={this.onSearchChange}
            placeholder='Search Sections'
          />
          {
            data.length > 0 ?
            <Table celled striped size='small'>
              <Table.Header>
                {headers}
              </Table.Header>
              <Table.Body>{body}</Table.Body>
            </Table> :
            <h3>No reviewed items.</h3>
          }
        </Modal.Content>
        <Modal.Actions>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default ReviewedModal;
